module.exports = ".underwrite-btn {\n  margin-top: 0.4rem;\n  margin-left: 0.85rem;\n  padding-top: 0.3rem;\n  border-radius: 2rem;\n  cursor: pointer;\n  height: 1.6rem; }\n\n.view-property-btn {\n  margin-top: 0.4rem;\n  border-radius: 2rem;\n  cursor: pointer;\n  height: 1.6rem;\n  width: 60%; }\n\n.view-property-btn-container {\n  color: #fff; }\n\n.tooltip-title {\n  color: #0076CC;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/property/components/map/property-tooltip.component.scss
// module id = ./src/app/features/property/components/map/property-tooltip.component.scss
// module chunks = main